module.exports = __webpack_public_path__ + "img/pedidosFill.ef8ca848.svg";